

const MAX_DIGIT = 7;
const DECI_MAX_DIGIT = 10;

export default function parseAmount(value) {
  let inputAmount = '';

  if (value.startsWith('0') || value.startsWith('.')) {
    return;
  }

  if (value.indexOf('.') === -1) {
    if (value.length > MAX_DIGIT) {
      return;
    }
  } else if (value.length > DECI_MAX_DIGIT) {
    return;
  }

  if (value.match(/[^0-9\.]+/g)) {
    return;
  }

  if (value.indexOf('.') > -1) {
    let eventVal = value.split('.');
    inputAmount = eventVal[1].replace(/\D/g, '');
    eventVal[1] = inputAmount;

    if (eventVal[1].length > 2 || eventVal[0].length > 7) {
      return;
    }

    eventVal = eventVal.slice(0, 2); // Avoid accepting multiple decimals in input

    inputAmount = eventVal.join('.');

    return inputAmount;
  } else {
    inputAmount = value.replace(/[^0-9\.]+/g, '');
    return inputAmount;
  }
}
